import styled from "styled-components";

export const HeaderContainer = styled.header`
  font-family: "Pretendard";
  position: relative;
  z-index: 11;
  padding: 0;
  .inner {
    max-width: 1440px;
    padding: 20px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #000;
    width: 100%;
    position: relative;
  }
  .shopLogo {
    position: relative;
    width: 150px;
    aspect-ratio: 2 / 1;
    padding-bottom: 0;
    cursor: pointer;
    color: #000;
    &.text {
      display: flex;
      justify-content: center;
      width: auto;
      aspect-ratio: auto;
      font-size: 20px;
    }
    span {
      white-space: nowrap;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .gnb,
  .tnb {
    display: flex;
    align-items: center;
    li {
      cursor: pointer;
      user-select: none;
    }
  }
  .gnb {
    font-size: 20px;
    font-weight: 500;
    gap: 2rem;
    white-space: nowrap;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .tnb {
    font-size: 14px;
    flex-wrap: wrap;
    gap: 10px;
    .tnb_btn {
      a:hover {
        color: #000;
      }
    }
    a {
      transition: 0.3s;
    }
    i {
      font-size: 16px;
      svg {
        display: block;
        margin: auto;
      }
    }
  }
  &.theme-2 {
    max-width: 1240px;
  }
  &.theme-0,
  &.theme-2 {
    .inner {
      display: block;
      > div {
        display: flex;
        &:nth-child(1) {
          justify-content: flex-end;
          gap: 40px;
          button {
            font-size: 14px;
            border: none;
            background: transparent;
          }
        }
        &:nth-child(2) {
          justify-content: space-between;
          align-items: center;
          margin: 20px 0;
          .search {
            width: 480px;
            height: 42px;
            border: 1px solid #cf4e8e;
            display: flex;
            justify-content: space-between;
            border-radius: 35px;
            align-items: center;
            padding: 0 30px;
            cursor: pointer;
            span {
              color: #a1a3a1;
              font-size: 14px;
            }
            i {
              font-size: 30px;
              color: #cf4e8e;
              svg {
                display: block;
                margin: 0;
              }
            }
          }
          .search ~ ul {
            display: flex;
            gap: 35px;
            li {
              cursor: pointer;
              img {
                width: 48px;
                height: 48px;
              }
            }
          }
        }
        &:nth-child(3) {
          gap: 50px;
          .category,
          .gnb {
            font-size: 16px;
          }
          .category {
            position: relative;
            > button {
              color: #cf4e8e;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 12px;
              width: 170px;
              position: relative;
              background: transparent;
              border: none;
              border-left: 1px solid #cdcdcd;
              border-right: 1px solid #cdcdcd;
            }
            svg {
              display: block;
              font-size: 22px;
            }
            .column button {
              border: none;
              transition: 0.2s;
              &:hover {
                background: #eee;
                color: #cf4e8e;
              }
            }
          }
          .gnb {
            gap: 10px 40px;
            color: #222;
            font-weight: 300;
          }
        }
      }
    }
  }
  &.theme-4 {
    position: absolute;
    background: transparent;
    border-bottom: 1px solid #d3d3d3;
    height: 80px;
    .support {
      font-size: 14px;
      margin-right: 10px;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #000d24;
        border-radius: 5px;
        width: 120px;
        height: 40px;
        color: #fff;
      }
    }
    .inner {
      height: 100%;
    }
    .shopLogo,
    ul li,
    a {
      color: #000;
    }
    .gnb {
      font-weight: 700;
      gap: 7rem;
      li {
        font-weight: normal;
        transition: 0.3s;
        text-transform: uppercase;
        &:hover {
          color: rgb(0, 33, 83);
        }
      }
    }
    .tnb {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 1050px) {
    .inner {
      padding: 10px 20px;
    }
    .gnb {
      display: none;
    }
    .tnb {
      font-size: 16px;
      i {
        font-size: 24px;
      }
    }
    .shopLogo {
      width: 100px;
    }
    &.theme-0,
    &.theme-2 {
      .inner > div {
        &:nth-child(1) {
          display: block;
          position: absolute;
          bottom: 10px;
          right: 20px;
        }
        &:nth-child(2) {
          margin: 0 0 10px 0;
        }
        &:nth-child(2) .search ~ ul,
        &:nth-child(2) .search span,
        &:nth-child(3) span {
          display: none;
        }
        &:nth-child(2) .search {
          width: auto;
          padding: 0;
          border: none;
          gap: 15px;
          i {
            font-size: 24px;
          }
        }
        .gnb {
          display: flex;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .shopLogo.text {
      font-size: 16px;
    }
    .tnb {
      font-size: 12px;
      li {
        display: none;
        &.tnb_btn {
          display: block;
        }
      }
    }
    &.theme-0,
    &.theme-2 {
      padding: 0;
      .inner > div {
        &:nth-child(1),
        &:nth-child(3) {
          display: none;
        }
        &:nth-child(2) {
          margin-bottom: 0;
          .search i {
            color: #000;
          }
        }
      }
    }
    &.theme-4 {
      padding: 0;
    }
  }
`;

export const SearchFormContainer = styled.div`
  position: absolute;
  top: 100%;
  background: #fff;
  width: 100vw;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;
  transition: 0.3s;
  z-index: 10;
  &.active {
    max-height: 100vh;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -3px, rgba(0, 0, 0, 0.3) 0px 1px 3px -7px;
  }
  &.inactive {
    max-height: 0;
  }
  button {
    border: none;
  }
  > div {
    max-width: 1240px;
    padding: 20px;
    margin: 0 auto;
    display: flex;
    &:nth-child(1) {
      align-items: center;
      justify-content: space-between;
      .form {
        border-bottom: 1px solid #cf4e8e;
        width: calc(100% - 60px);
        position: relative;
        input {
          width: 100%;
          border: none;
          height: 50px;
          padding: 0 40px 0 20px;
          font-size: 16px;
          &:focus {
            border: none !important;
            box-shadow: none;
          }
        }
        button {
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          width: 30px;
          height: 30px;
          font-size: 30px;
          color: #cf4e8e;
          background: transparent;
        }
      }
      .form ~ button {
        width: 30px;
        height: 30px;
        font-size: 30px;
        color: #828282;
        background: transparent;
      }
    }
    &:nth-child(2) {
      align-items: flex-start;
      justify-content: space-between;
      font-size: 16px;
      > div {
        width: calc(50% - 20px);
        color: #484848;
      }
      .tit {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        height: 32px;
        button {
          font-size: 12px;
          width: 62px;
          height: 32px;
          border: 1px solid #ccc;
          background: transparent;
          border-radius: 3px;
          color: #6c6c6c;
        }
        span:nth-child(2) {
          font-size: 14px;
          color: #999;
        }
      }
      ul {
        li {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .recent {
      svg {
        display: block;
        margin: auto;
      }
      li {
        justify-content: space-between;
        > span {
          display: flex;
          gap: 10px;
          align-items: center;
          cursor: pointer;
          i {
            background: #f2f2f2;
            border-radius: 50%;
            width: 24px;
            height: 24px;
            text-align: center;
            display: flex;
          }
        }
        > div {
          display: flex;
          align-items: center;
          gap: 10px;
          button {
            background: transparent;
            color: #828282;
            font-size: 18px;
          }
        }
      }
    }
    .popular {
      li {
        gap: 10px;
        span:nth-child(1) {
          display: inline-block;
          width: 22px;
          height: 22px;
          line-height: 22px;
          background: #888;
          color: #ffff;
          font-weight: 900;
          text-align: center;
          font-size: 14px;
          border-radius: 3px;
        }
        &:nth-child(-n + 3) span:nth-child(1) {
          background: #c2141b;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    position: fixed;
    top: 0;
    height: 100vh;
    overflow-y: auto;
    z-index: 9999;
    transform: none;
    left: 0;
    > div:nth-child(1) {
      flex-direction: row-reverse;
      .form {
        border-bottom: none;
        width: calc(100% - 36px);
        button {
          display: none;
        }
        input {
          background: #f2f2f2;
          border-radius: 5px;
          height: 36px;
          font-size: 14px;
          padding: 0 10px;
        }
      }
      .form ~ button {
        width: 26px;
        height: 26px;
        font-size: 24px;
      }
    }
    > div:nth-child(2) {
      font-size: 14px;
      display: block;
      padding-top: 0;
      > div {
        width: 100%;
      }
      .tit {
        margin-bottom: 15px;
      }
    }
    .popular {
      margin-top: 20px;
    }
  }
`;

export const FixedHeaderContainer = styled.div`
  height: 52px;
  position: fixed;
  background: #eaf7ed;
  width: 100vw;
  z-index: 100;
  font-family: "Pretendard";
  font-size: 14px;
  button {
    border: none;
    svg {
      display: block;
      margin: auto;
    }
  }
  .inner {
    width: 100%;
    height: 100%;
    max-width: 1440px;
    padding: 7px 20px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* color: #fff; */
    position: relative;
    > div:nth-child(1) {
      display: flex;
      align-items: center;
      height: 100%;
      gap: 20px;
    }
  }
  .category {
    position: relative;
    button {
      background: transparent;
      border: none;
      font-size: 30px;
      svg {
        display: block;
      }
    }
  }
  img {
    max-width: 76px;
    max-height: 38px;
    aspect-ratio: 2 / 1;
    object-fit: contain;
  }
  .search {
    width: 300px;
    height: 100%;
    background: #fff;
    display: flex;
    justify-content: space-between;
    border-radius: 35px;
    align-items: center;
    padding: 0 20px;
    cursor: pointer;
    span {
      color: #a1a3a1;
      font-size: 14px;
    }
    i {
      font-size: 30px;
      color: #000;
      svg {
        display: block;
        margin: 0;
      }
    }
  }
  .gnb {
    display: flex;
    align-items: center;
    gap: 20px;
    font-size: 16px;
    white-space: nowrap;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    li {
      cursor: pointer;
    }
  }
  &.theme-2 {
    .inner {
      max-width: 1240px;
    }
  }
  @media screen and (max-width: 1050px) {
    .search,
    .inner ~ div {
      display: none;
    }
  }
  @media screen and (max-width: 767px) {
    .inner {
      > div:nth-child(1) {
        display: none;
      }
    }
  }
`;

export const CategoryTree = styled.div`
  position: absolute;
  top: 100%;
  transform: translateY(5px);
  left: 0;
  font-size: 14px;
  background: #fff;
  z-index: 10;
  .tree {
    position: relative;
    padding: 0;
    > div {
      position: relative;
      height: auto;
    }
  }
  .column {
    position: absolute;
    left: 0;
    background: #fafafa;
    border: 1px solid #ddd;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 10;
    button {
      display: block;
      width: 120px;
      height: 30px;
      color: #444;
      white-space: nowrap;
      background: transparent;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      &:hover {
        background: rgb(234, 247, 237);
        color: #000;
        font-weight: 700;
      }
    }
  }
`;
